import React, { useMemo } from "react";
import PropTypes from "prop-types";
import UserAdminAccount from "./UserAdminAccount";
import classes from "./UserAdminAccounts.module.scss";
import Spinner from "components/Spinner";

const UserAdminAccountsView = ({ accounts = [], loading = false }) => {
  // Normalize to array defensively
  const list = Array.isArray(accounts) ? accounts : [];

  // Sort once per change
  const alphabetizedAccounts = useMemo(() => {
    return [...list].sort((a, b) => {
      const an = (a?.name || "").toLowerCase();
      const bn = (b?.name || "").toLowerCase();
      if (an === bn) return 0;
      return an > bn ? 1 : -1;
    });
  }, [list]);

  // Render rows
  const rows = useMemo(
    () =>
      alphabetizedAccounts.map((account) => (
        <UserAdminAccount key={account.accountId || account.id} account={account} />
      )),
    [alphabetizedAccounts]
  );

  return (
    <div className={classes.container}>
      <div className={classes["accounts-bar"]}>
        <div className="container-fluid">
          <div className="row pt-2 pb-2">
            <div className="col-auto">
              <span className="white-text bar-text">Accounts</span>
            </div>
          </div>
        </div>
      </div>

      <div className={classes["column-headers-bar"]}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-3">
              <span className="white-text">Account</span>
            </div>
            <div className="col-3">
              <span className="white-text">Role</span>
            </div>
            <div className="col" />
            <div className="col-2">
              <span className="white-text">Add/Modify Role</span>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="p-3 text-center"><Spinner /></div>
      ) : alphabetizedAccounts.length > 0 ? (
        <div className={classes.content}>{rows}</div>
      ) : (
        <div className="p-3 text-center text-muted">No accounts found.</div>
      )}
    </div>
  );
};

UserAdminAccountsView.propTypes = {
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      accountId: PropTypes.string,
      id: PropTypes.string,        // allow either
      name: PropTypes.string,
      brand: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      role: PropTypes.string,
      accountProfileId: PropTypes.string
    })
  ),
  loading: PropTypes.bool
};

export default UserAdminAccountsView;
